import { Component, OnInit } from '@angular/core';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { AccountClientDetailsService } from '../../../service/account-client-edit/account-client-details.service';
import { FlashMessagesService } from 'angular2-flash-messages';
import * as moment from 'moment';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { IMyDpOptions } from 'mydatepicker';

export interface SolicitarLcAdicionalModel {
  clientID;
  vigenciaLC;
}

@Component({
  selector: 'app-solicitar-lc-adicional',
  templateUrl: './solicitar-lc-adicional.component.html',
  styleUrls: ['./solicitar-lc-adicional.component.scss'],
  providers: [AccountClientDetailsService]
})
export class SolicitarLcAdicionalComponent extends DialogComponent<SolicitarLcAdicionalModel, any> implements SolicitarLcAdicionalModel, OnInit {
  
  clientID;
  vigenciaLC;
  form: FormGroup;
  private ctcList;

  public myDatePickerOptions: IMyDpOptions = {
		// other options...
		dayLabels: { su: 'Dom', mo: 'Seg', tu: 'Ter', we: 'Qua', th: 'Qui', fr: 'Sex', sa: 'Sab' },
		monthLabels: { 1: 'Jan', 2: 'Fev', 3: 'Mar', 4: 'Abr', 5: 'Mai', 6: 'Jun', 7: 'Jul', 8: 'Ago', 9: 'Set', 10: 'Out', 11: 'Nov', 12: 'Dez' },
		dateFormat: 'dd/mm/yyyy',
		showTodayBtn: false,
		//disableSince: {year: this.today.year(), month: this.today.month()+1, day: this.today.date()},
		//disableUntil: {year: this.today.getFullYear(), month: this.today.getMonth()+1, day: this.today.getDate()},
		//disableDateRanges: [{begin: {year: 2016, month: 11, day: 14}, end: {year: 2016, month: 11, day: 20}}],
		//editableDateField: false,
		height: "30px"
	};
  
  constructor(dialogService: DialogService,
    private fb: FormBuilder,
    private accountClientDetailsService: AccountClientDetailsService,
    private flashMessagesService: FlashMessagesService) {
    super(dialogService);
  }

  ngOnInit() {
    this.getCTCByAccountClient();

    this.form = this.fb.group({
      keepProposal: [true],
      codigoSap: ['', [Validators.required]],
      valorSolicitado: [0, [Validators.required]],
      vigencia: [null, [Validators.required]],
      justificativa: ['', [Validators.required]],
      fileDescription: [''],
      fileSource: [''],
      fileName: [''],
    })
  }

  onFileChange(event: any) {
    if (event.target.files.length > 0) {   
      const files = event.target.files;

      const fileSource = this.form.get('fileSource');
      const fileName = this.form.get('fileName');

      fileSource.patchValue(files[0]);
      fileName.patchValue(files[0].name);
    }
  }

  confirm() {
    let vigenciaAtual = moment(this.vigenciaLC).add(1, 'years').toDate();
    let vigenciaAdicional = moment(this.form.value.vigencia.jsdate).toDate();
    let fileName = this.form.get('fileName');
    let fileDescription = this.form.get('fileDescription');

    if (!this.form.valid) {
      this.flashMessagesService.show('Por favor, preencha todos os campos do formulário', { cssClass: 'alert-danger', timeout: 6000 })
      return;
    }

    if (vigenciaAdicional > vigenciaAtual) {
      this.flashMessagesService.show(`A vigência do LC Adicional não pode ser superior a ${moment(vigenciaAtual).format("DD/MM/YYYY")}`, { cssClass: 'alert-danger', timeout: 6000 })
      return;
    }

    if (fileName.value != null && fileName.value != "" && fileDescription.value != null && fileDescription.value == "") {
      this.flashMessagesService.show(`O anexo deve ter uma descrição`, { cssClass: 'alert-danger', timeout: 6000 })
      return;
    }

    this.result = this.form.value;
    this.close();
  }

  getCTCByAccountClient() {
		this.accountClientDetailsService.getCtcByAccountClient(this.clientID).subscribe(result => {
			if (result.Success) {
				this.ctcList = result.Result;
			} else {
				this.flashMessagesService.show(result.Errors, { cssClass: 'alert-danger', timeout: 6000 });
			}
		}, error => {
			console.log(error);
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/account-client/component/account-client-details/solicitar-lc-adicional/solicitar-lc-adicional.component.ts